import { Text, UseDisclosureReturn, VStack } from "@chakra-ui/react";
import {
  AccountAccessRole,
  AccountAccessRoleName,
} from "@syla/shared/types/models/AccountAccessBase";
import { AccountAccessWithUserPopulated } from "@syla/shared/types/responses/GetAccountsResponse";
import React from "react";
import { ConfirmActionModal } from "../../../components/modals/ConfirmActionModal";
import { useMutationUpdateAccountAccess } from "../../../store/useMutationUpdateAccountAccess";

export function DowngradeOwnAccountAccessModal({
  accountId,
  accountAccess,
  newRole,
  disclosure,
  onSuccess,
}: {
  accountId: string;
  accountAccess: AccountAccessWithUserPopulated;
  newRole: AccountAccessRole;
  disclosure: UseDisclosureReturn;
  onSuccess: (role: AccountAccessRole) => void;
}): React.ReactElement {
  const mutationUpdateAccountAccess = useMutationUpdateAccountAccess(accountId);

  const saveRole = async () => {
    await mutationUpdateAccountAccess.mutateAsync({
      ops: [
        {
          userId: accountAccess.user._id,
          action: "set",
          role: newRole,
        },
      ],
    });

    onSuccess(newRole);
  };

  return (
    <ConfirmActionModal
      disclosure={disclosure}
      title="Downgrade your access"
      confirmButtonText="Downgrade my access"
      colorScheme="red"
      onConfirm={saveRole}
    >
      <VStack alignItems="stretch" spacing={6}>
        <Text>
          You are about to downgrade your access from{" "}
          <Text as="span" fontWeight="bold">
            {AccountAccessRoleName[accountAccess.role]}
          </Text>{" "}
          to{" "}
          <Text as="span" fontWeight="bold">
            {AccountAccessRoleName[newRole]}
          </Text>
          .
        </Text>

        <Text>This will reduce your ability to manage the account.</Text>
      </VStack>
    </ConfirmActionModal>
  );
}
